<template>
  <div
    v-if="isActive"
    class="release-bar"
  >
    <horizontal-bar-with-ideal
      :glow="false"
      :mark="releasePhaseState.markPosition"
      :gradient="barValues"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { HorizontalBarWithIdeal } from '@powerplay/core-minigames-ui-ssm'
import { shootingConfig } from '@/app/config'
import { ShootingTypes } from '@/app/types'
import { releasePhaseState } from '@/stores'

export default defineComponent({
  name: 'ReleaseBar',
  components: {
    HorizontalBarWithIdeal
  },
  data() {

    return {
      releasePhaseState: releasePhaseState()
    }

  },
  computed: {
    isActive() {

      return shootingConfig.type === ShootingTypes.bar && releasePhaseState().isActive

    },
    barValues() {

      return shootingConfig.barType.barColorLimits

    }
  }
})

</script>

<style lang="less" scoped>
.release-bar {
  position: absolute;
  bottom: 5%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}
</style>
